import { FC } from 'react';
import AIAvatar from '../AIAvatar/AIAvatar';
import MarkdownView from '../MarkdownView/MarkdownView';
import TypingMarkdown from '../TypingMarkdown/TypingMarkdown';

interface BotReplyProps {
    message: string;
    isTyping: boolean;
}
const BotReply: FC<BotReplyProps> = (props) => {
    const { message, isTyping } = props;

    return (
        <div className="flex gap-3 ">
            {/* <AIAvatar size={20} className="mt-[2px]" showIcon={false} /> */}

            <div className="relative max-w-[90%] px-4 py-3 rounded-xl rounded-tl-none">
                {/* ai-gradient */}
                {/* <div className="absolute inset-0 rounded-xl rounded-tl-none"></div> */}
                <div className="relative text-sm text-grayscale-600 break-words">
                    {isTyping ? <TypingMarkdown message={message} /> : <MarkdownView message={message} />}
                </div>
            </div>
        </div>
    );
};

export default BotReply;
